module.exports = __webpack_public_path__ + "img/pricing_woman.a3579253.svg";